import React from 'react';
import { Modal } from 'antd';
// Types
import { GetCampaignOffers_getCampaignOffers_entities } from 'api/campaignV2/types/GetCampaignOffers';
import { CampaignType } from 'api/graphql-global-types';
// Components
import SocialDeliverables from './components/SocialDeliverables/SocialDeliverables';
import SponsoredDeliverables from './components/SponsoredDeliverables/SponsoredDeliverables';
import SocialShareDeliverables from './components/SocialShareDeliverables/SocialShareDeliverables';
import { CampaignVersion } from 'constants/global';
import SocialDeliverablesV2 from './components/SocialDeliverables/SocialDeliverablesV2';
import DeliverablesSubmitTimeline from 'components/common/SocialCampaignV2Components/DeliverablesSubmitTimeline/DeliverablesSubmitTimeline';
// Helpers
import { isCustomLikeCampaign } from 'helpers/campaign';

type CampaignDeliverablesProps = {
  record: GetCampaignOffers_getCampaignOffers_entities | null;
  onClose: () => void;
  onFinish: () => void;
};
const CampaignDeliverables = ({
  record,
  onClose,
  onFinish,
}: CampaignDeliverablesProps): JSX.Element => {
  const campaignType = record?.campaign.type;
  const isSocial = campaignType === CampaignType.Social;
  const isSocialShare = campaignType === CampaignType.SocialShare;
  const isAppearance = campaignType === CampaignType.SponsoredAppearance;
  const isCampaignV2 = record?.campaign.v === CampaignVersion.V2;
  // V3 Custom, DirectBooking and UGC offers have no dedicated view, so they
  // show their deliverablesV2 through the deliverables timeline
  const isTimelineView =
    record?.campaign.v === CampaignVersion.V3 &&
    (isCustomLikeCampaign(campaignType) || campaignType === CampaignType.Ugc);

  return (
    <>
      {isTimelineView && (
        <Modal
          title="Deliverables"
          visible={!!record}
          footer={null}
          onCancel={onClose}
          width="850px"
        >
          <DeliverablesSubmitTimeline offer={record} />
        </Modal>
      )}
      {isSocial && (
        <>
          {isCampaignV2 ? (
            <SocialDeliverablesV2
              record={record}
              onClose={onClose}
              onFinish={onFinish}
            />
          ) : (
            <SocialDeliverables
              record={record}
              onClose={onClose}
              onFinish={onFinish}
            />
          )}
        </>
      )}
      {isSocialShare && (
        <SocialShareDeliverables
          record={record}
          onClose={onClose}
          onFinish={onFinish}
        />
      )}
      {isAppearance && (
        <SponsoredDeliverables
          record={record}
          onClose={onClose}
          onFinish={onFinish}
        />
      )}
    </>
  );
};

export default CampaignDeliverables;
